import {NgModule} from '@angular/core'
import {CommonModule} from '@angular/common'
import {BsDropdownModule} from 'ngx-bootstrap/dropdown'

import {FilterListComponent} from './filter-list.component'
import {FilterListHeaderDirective} from './filter-list-header.directive'
import {FilterListItemHeaderDirective} from './filter-list-item-header.directive'
import {FilterListItemExpandDirective} from './filter-list-item-expand.directive'

import {InfiniteScrollModule} from 'ngx-infinite-scroll'
import {LoaderLineModule} from '../loader-line/loader-line.module'
import {SearchFilterModule} from '../search-filter/search-filter.module'
import {DateFilterModule} from '../date-filter/date-filter.module'
import {NgxPermissionsModule} from 'ngx-permissions'
import {FilterListExtraBarDirective} from './filter-list-extra-bar.directive'
import {TableExportComponent} from '../app-table-export/app-table-export.component'
import {FilterListItemHeaderLabelDirective} from './filter-list-item-header-label.directive'
import {CdkDragPlaceholder} from '@angular/cdk/drag-drop'

@NgModule({
  imports: [
    CommonModule,
    BsDropdownModule,
    InfiniteScrollModule,
    LoaderLineModule,
    SearchFilterModule,
    DateFilterModule,
    NgxPermissionsModule.forChild(),
    CdkDragPlaceholder,
  ],
  declarations: [
    FilterListComponent,
    FilterListHeaderDirective,
    FilterListItemHeaderDirective,
    FilterListItemExpandDirective,
    FilterListExtraBarDirective,
    TableExportComponent,
    FilterListItemHeaderLabelDirective,
  ],
  exports: [
    FilterListComponent,
    FilterListHeaderDirective,
    FilterListItemHeaderDirective,
    FilterListItemExpandDirective,
    FilterListExtraBarDirective,
    TableExportComponent,
    FilterListItemHeaderLabelDirective,
  ],
})
export class FilterListModule {}
